<template>
  <v-dialog v-model="dialog.show" persistent max-width="900">
    <v-card>
      <v-card-title class="pl-0 pr-0 pt-0 ml-0 mr-0 mt-0">
        <v-toolbar :color="this.getAppBarColor">
          <v-toolbar-title>
            <v-row dense justify="center" align="center">
              <v-col cols="12">
                <span class="align-center">
                  <p class="white--text">{{ dialog.title }}</p>
                </span>
              </v-col>
            </v-row>
          </v-toolbar-title>
        </v-toolbar>
      </v-card-title>
      <v-card-text>
        <v-form ref="formBusca">
          <v-row dense>
            <v-col cols="12" sm="12" md="4">
              <SelectEmpresa
                :multiple="false"
                @onChanged=" getEmpresas($event)"
                @onEmpresas="empresasArray = $event"
              />
            </v-col>
            <v-col cols="12" sm="12" md="4">
              <SelectColaborador
                :multiple="true"
                :empresas="empresas"
                @onChanged="equipe.colaboradores = $event"
                :equipes="equipes"
              />
            </v-col>
            <v-col cols="12" sm="12" md="4">
              <v-text-field
                v-model="equipe.codigoEquipe"
                :rules="[rules.required]"
                label="Código da Equipe"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="12" md="4">
              <v-text-field v-model="equipe.nome" :rules="[rules.required]" label="Nome da Equipe"></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="4">
              <SelectColaborador1
                :multiple="false"
                :empresas="empresas"
                label="Supervisor"
                @onChanged="equipe.supervisor = $event"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          class="ma-3 pl-5 pr-5"
          outlined
          color="blue darken-1"
          small
          dark
          rounded
          depressed
          @click="store"
        >Salvar</v-btn>

        <v-btn
          class="ma-3 pl-5 pr-5"
          outlined
          color="red darken-2"
          small
          dark
          rounded
          depressed
          @click="reset()"
        >Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Equipe from "@/services/equipe";
import rules from "@/utils/rules";
export default {
  components: {
    SelectEmpresa: () => import("@/components/select/SelectEmpresa"),
    SelectColaborador: () => import("@/components/select/SelectColaborador2"),
    SelectColaborador1: () => import("@/components/select/SelectColaborador")
  },
  data() {
    return {
      rules: rules,
      empresas: null,
      colaboradores: null,
      empresasArray: [],
      dialog: {
        show: false,
        title: "Adicionar Equipe"
      },
      equipe: {
        nome: "",
        supervisor: "",
        codigoEquipe: "",
        dataCriacao: new Date(),
        colaboradores: [],
        ativo: true
      },
      equipes: []
    };
  },
  methods: {
    getFormartCpf(valor) {
      return valor.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "$1.$2.$3-$4");
    },
    show() {
      this.dialog.show = true;
    },
    async store() {
      if (this.$refs.formBusca.validate()) {
        let response = null;
        try {
          response = await new Equipe().selectEquipeCodigo(
            this.empresas,
            this.equipe.codigoEquipe
          );
        } catch (error) {
          this.$swal.error(error);
        }
        if (response === null) {

          var colaboradores = [];
          this.equipe.colaboradores.forEach(el => {
            colaboradores.push({
              ativo: el.ativo ? "S" : "N",
              colaborador: el.nome,
              cpf_completo: el.cpf,
              funcao: el.funcao ? el.funcao : ""
            });
          });
          this.equipe.colaboradores = colaboradores;
          try {
            // const equipes = {
            //   colaboradoreres: colaboradores,
            //   nome: this.equipe.nome,
            //   supervisor: this.equipe.supervisor[0].cpf,
            //   codigoEquipe: this.equipe.codigoEquipe,
            //   dataCriacao: new Date(),
            //   ativo: this.equipe.ativo
            // };

            await new Equipe().insertEquipe(this.empresas, this.equipe);
            this.$swal.success("Equipe Cadastrada com Sucesso");
          } catch (error) {
            console.error(error);
          }
        } else {
          this.$swal.warning("Código da Equipe Já Cadastrado");
        }
      }
      //   try {
      //     await this.equipe();
      //   } catch (error) {
      //     console.log(error);
      //   }
    },
    reset() {
      this.dialog.show = false;
      this.empresa = null;
      this.empresasArray = [];
    },
    async getEquipes(empresas) {
      try {
        const response = await new Equipe().selectEquipeAll(empresas);
        this.equipes.push(response);
      } catch (error) {
        console.error(error);
      }
    },
    async getEmpresas(empresas) {
      this.empresas = empresas;
      await this.getEquipes(empresas);
    }
  }
};
</script>

<style>
</style>
